import { render, staticRenderFns } from "./AppFeed.vue?vue&type=template&id=cce54052&scoped=true&"
import script from "./AppFeed.vue?vue&type=script&lang=js&"
export * from "./AppFeed.vue?vue&type=script&lang=js&"
import style0 from "./AppFeed.vue?vue&type=style&index=0&id=cce54052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce54052",
  null
  
)

export default component.exports